module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_GUM.69827ba6.png";